// extracted by mini-css-extract-plugin
module.exports = {"footer":"_93444fe79c--footer--qIHDl","metroWrapper":"_93444fe79c--metroWrapper--yvXMs"};